import React from 'react';
import ReactDOM from 'react-dom';
import { ConfigProvider, message, Table } from 'antd';
import 'moment/locale/zh-cn';

import zhCN from 'antd/es/locale/zh_CN';
import { Provider } from 'react-redux';
import { store } from "./store";

import App from './App';
import reportWebVitals from './reportWebVitals';
import moment from 'moment';


moment.locale('zh-cn');

message.config({
  maxCount: 1,
  top: document.body ? Math.ceil(document.body.clientHeight / 2) : 300,
});


ReactDOM.render(
	<ConfigProvider locale={zhCN}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>,
	document.getElementById('root')
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
